import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow,  } from '@material-ui/core';  // Importação corrigida

const PlagiarismTable = ({ data }) => {
  return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Ocorrências</TableCell>
            <TableCell>Similaridade</TableCell>
            <TableCell>URL</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.occurrences}</TableCell>
              <TableCell>{item.similarity}</TableCell>
              <TableCell>
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.url}
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
  );
};

export default PlagiarismTable;
